import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["equivalence", "input", "button"];

  inputObserver;

  connect() {
    this.updateEquivalencyQuantity = this.updateEquivalencyQuantity.bind(this);
    this.handleChange();
    this.updateDisabled();

    this.inputObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === "disabled") {
          this.updateDisabled();
        }
      });
    });

    this.inputObserver.observe(this.inputTarget, {
      attributes: true
    });
  }

  disconnect() {
    this.inputObserver.disconnect();
  }

  updateDisabled() {
    this.buttonTargets.forEach((button) => {
      button.disabled = this.inputTarget.disabled || this.inputTarget.readOnly;
    });
  }

  equivalenceTargetConnected(element) {
    this.updateEquivalencyQuantity(element);
  }

  handleChange() {
    if (this.hasEquivalenceTarget) {
      this.equivalenceTargets.forEach(this.updateEquivalencyQuantity);
    }
  }

  updateEquivalencyQuantity(element) {
    const [quantity, unit] = this.getQuantityAndUnit();
    element.dataset["inputs-QuantityWithUnit-EquivalenceQuantityValue"] =
      quantity;
    const radio = element.querySelector('input[type="radio"]');
    radio.checked = radio.value === unit;
  }

  getQuantityAndUnit() {
    return this.inputTarget.value.split(/\s+/, 2);
  }

  handleEquivalenceSelect(e) {
    const [quantity] = this.inputTarget.value.split(/\s+/, 2);
    this.inputTarget.value = `${quantity || 1} ${e.target.value}`;
  }

  increase() {
    if (this.inputTarget.disabled || this.inputTarget.readOnly) {
      return;
    }
    const [quantity, unit] = this.inputTarget.value.split(/\s+/, 2);
    let newValue = quantity;
    const maxValue = parseFloat(this.inputTarget.dataset.max ?? "");
    if (this.inputTarget.dataset.max && parseFloat(quantity) >= maxValue) {
      newValue = maxValue;
    } else {
      newValue = (parseFloat(quantity) || maxValue) + 1;
    }

    this.inputTarget.value = `${newValue} ${unit || this.firstUnitOfMesure()}`;
    this.inputTarget.dispatchEvent(new Event("change"));
  }

  decrease() {
    if (this.inputTarget.disabled || this.inputTarget.readOnly) {
      return;
    }
    let [quantity, unit] = this.inputTarget.value.split(/\s+/, 2);
    const minValue = parseFloat(this.inputTarget.dataset.min ?? "");

    quantity = parseFloat(quantity || "0");
    unit = unit || this.firstUnitOfMesure();
    if (this.inputTarget.dataset.min && quantity - 1 < minValue) {
      this.inputTarget.value = `${minValue} ${unit}`;
    } else {
      this.inputTarget.value = `${parseFloat(quantity) - 1} ${unit}`;
    }
    this.inputTarget.dispatchEvent(new Event("change"));
  }

  firstUnitOfMesure() {
    if (this.hasEquivalenceTarget) {
      const radio = this.equivalenceTargets[0].querySelector(
        'input[type="radio"]'
      );
      return radio?.value || "";
    }

    return "";
  }
}
